module.exports = __webpack_public_path__ + "img/Picture20.74b2f42b.png";